import HomepageTemplate from 'gatsby-theme-carbon/src/templates/Homepage';
import React from 'react';
export default {
  HomepageTemplate,
  React
};